var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99988 1V2.00474M6.00898 15.9034C7.99669 16.1269 10.0031 16.1269 11.9908 15.9034C11.9767 16.0967 11.9464 16.2887 11.9 16.4772L11.8181 16.8106C11.5612 17.855 10.7454 18.6678 9.70376 18.917C9.24097 19.0277 8.75878 19.0277 8.296 18.917C7.25438 18.6678 6.43851 17.855 6.1817 16.8106L6.09973 16.4772C6.05338 16.2887 6.02305 16.0967 6.00898 15.9034ZM3.02768 6.63259C3.582 4.58674 5.14989 2.95325 7.15826 2.30223C8.3926 1.90211 9.73482 1.90145 10.9669 2.30838C12.9397 2.9599 14.4499 4.57084 14.9792 6.58835L15.5624 8.81121L16.0297 10.9275C16.1736 11.5793 16.3694 12.2498 16.4727 12.9094C16.4906 13.0237 16.4999 13.141 16.4999 13.2604C16.4999 14.3266 15.7523 15.2453 14.7123 15.4572L14.3447 15.532C10.8174 16.2506 7.18239 16.2506 3.65506 15.532L3.28747 15.4572C2.24742 15.2453 1.49988 14.3266 1.49988 13.2604C1.49988 13.141 1.50917 13.0237 1.52707 12.9094C1.63031 12.2498 1.82614 11.5793 1.97007 10.9275L2.43738 8.81121L3.02768 6.63259Z",
    stroke: "#212121",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.7dd4b247aad0ee8368b29aff73789453.svg";
export { ForwardRef as ReactComponent };